<template>
<section class="bg-white py-3 border-t border-border">
    <div class="container-fluid text-center">
        <p class="content !m-0 !text-blackPrimary">© 2016 - {{ currentYear }} U.S. Legal Services. All Rights Reserved.</p>
    </div>
</section>

</template>
<script>
    export default {
        data() {
            return {
                currentYear: new Date().getFullYear()
            };
        }
    };
</script>